import request from '@/utils/request'

// 结算汇总（可提现/冻结/待缴费）
export function querySettleSummary(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/payFlow.settleSummary',
      method: 'post',
      data: params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 发起提现申请
export function applySettle(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/settle.applySettle',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 查询结算记录列表
export function listSettleOrders(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/settle.listSettleOrders',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 查询结算发票设置（物业收款账户）
export function querySettleAccount(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/settle.querySettleAccount',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 平台端：查询全部物业结算单（审批列表）
export function listAuditSettleOrders(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/settle.auditListOrders',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 平台端：审批（1 通过 / 2 驳回）
export function auditSettle(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/settle.auditSettle',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 平台端：银行渠道到账手动标记
export function arriveSettle(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/settle.arriveSettle',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 保存结算发票设置
export function saveSettleAccount(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/settle.saveSettleAccount',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}
